import { CSSProperties, useEffect, useRef } from "react";
import { cursorTrail } from "../utility/cursor-trail";

export interface CursorTrailCanvasProps {
  color?: string;
  className?: string;
  style?: CSSProperties;
}

const CursorTrailCanvas: React.FC<CursorTrailCanvasProps> = ({
  color,
  className,
  style,
}) => {
  const refCanvas = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!refCanvas.current) return;

    const { cleanUp, renderTrailCursor } = cursorTrail({
      ref: refCanvas, 
      color,
    });

    renderTrailCursor();

    return () => cleanUp();
  }, [color]);

  return <canvas ref={refCanvas} className={className} style={style}></canvas>;
};

export default CursorTrailCanvas;
